(() => {
  const selector = 'img.shopify-dns-link-icon';
  let observer;
  let stopTimer;

  function fixPrivacyChoiceIcons(root = document) {
    const icons = root.querySelectorAll ? root.querySelectorAll(selector) : [];

    icons.forEach((icon) => {
      icon.setAttribute('alt', '');
      icon.setAttribute('aria-hidden', 'true');
      icon.removeAttribute('role');
    });

    return icons.length > 0;
  }

  function stopWatching() {
    if (observer) observer.disconnect();
    if (stopTimer) window.clearTimeout(stopTimer);
  }

  function start() {
    fixPrivacyChoiceIcons();

    observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches(selector) || fixPrivacyChoiceIcons(node)) {
            fixPrivacyChoiceIcons();
            stopWatching();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Shopify normally inserts this control quickly. Stop observing if it does not.
    stopTimer = window.setTimeout(stopWatching, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
